import { Component, OnInit } from '@angular/core';
import { EnfermeiroService } from '../../enfermeiro.service';
import { NavigationExtras, Router } from '@angular/router';
import { AlertsService } from 'app/shared/alerts.service';
import { CartaoContasService } from 'app/shared/components/cartao-gestante/cartao-contas.service';
import { ModalsService } from 'app/shared/modals.service';

@Component({
    selector: 'app-enfermeiro-secretarias',
    templateUrl: './enfermeiro-secretarias.component.html',
    styleUrls: ['./enfermeiro-secretarias.component.scss']
})
export class EnfermeiroSecretariasComponent implements OnInit {

  loading: boolean = true; 
  secretarias: any = null;

  filtro_pesquisa: string = ''; 
  filtro_exibir: string = 'A'; 

  constructor(
    private enfermeiroService: EnfermeiroService, 
    private router: Router,
    private alerts: AlertsService,
    private modalService: ModalsService, 
    private contasService: CartaoContasService, 
    ) { }


  ngOnInit() {
    //this.overlayService.show(); 
    this.AtualizarInformacoes(); 
  }

  AtualizarInformacoes() {

    this.enfermeiroService.GetListaSecretarias().subscribe((res) => {
      
      this.secretarias = res; 
      this.loading = false; 
      
    }, err => {

      this.loading = false; 
      
    });
    
  }

  BloquearSecretaria(item) {
      
    this.modalService.AbrirModalDeConfirmacao('Bloquear o usuário?', 'Essa ação impedirá o login do médico e de qualquer alteração em relação aos seus pacientes, deseja continuar?')
    .subscribe((res) => {
      if(res) {
        this.enfermeiroService.BloquearSecretaria(item).then((res) => {
          this.AtualizarInformacoes(); 
          this.alerts.SnackMessage('Médico Bloqueado com sucesso!'); 
        })
      }
    })
  }

  DesbloquearSecretaria(item) {
    
    this.modalService.AbrirModalDeConfirmacao('Desbloquear o usuário?', 'Essa ação permitirá que o usuário acesse o sistema novamente, deseja continuar?')
    .subscribe((res) => {
      if(res) {
        this.enfermeiroService.DesbloquearSecretaria(item).then((res) => {
          this.AtualizarInformacoes(); 
          this.alerts.SnackMessage('Médico Desbloqueado com sucesso!'); 
        })
      }
    })
  }

  EditarSecretaria(item) {
    
    var navigationExtras: NavigationExtras = {
      state: {
        secretaria: item
      }
    }; 

    this.router.navigate(['/enfermeiro-alterar-secretarias'], navigationExtras);
  }

  ExcluirSecretaria(item) {
    
    this.modalService.AbrirModalDeConfirmacao('Excluir o usuário?', 'Essa ação apagará o registro da secretária e o impedirá de realizar novos logins, os pacientes deles não serão apagados, deseja continuar? ')
    .subscribe((res) => {
      if(res) {
        this.enfermeiroService.DeletarSecretaria(item).then((res) => {
          this.alerts.SnackMessage('Usuário excluído com sucesso!'); 
          this.AtualizarInformacoes(); 
        })
      } else {
        this.alerts.SnackMessage('Falha ao excluir o usuário'); 
      }
    })
  }
}